/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/react/EligibilityChecker.js":
/*!***************************************************!*\
  !*** ./js/components/react/EligibilityChecker.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/react-wrapper */ "./js/components/react-wrapper.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



// Questions configuration - can be modified as needed
var QUESTIONS = [{
  id: 'diabetes',
  text: 'Are you currently diagnosed with Type 1 or Type 2 diabetes?'
}, {
  id: 'insulin',
  text: 'Are you currently administering insulin either injected or inhaled?'
}, {
  id: 'hypoglycemic',
  text: 'Do you have hypoglycemic lows below 54?'
}];

// Contact page URL - update this to your actual contact page
var CONTACT_PAGE_URL = '/pages/contact';

// Outcome mapping - configure outcomes for each combination
// Key format: "diabetes-insulin-hypoglycemic" (yes/no values)
var OUTCOME_MAP = {
  'yes-yes-yes': {
    type: 'text',
    url: '/collections/cgms',
    message: '<strong>Based on your responses, you qualify for a CGM.</strong>',
    buttonText: "Explore CGM's"
  },
  'yes-yes-no': {
    type: 'text',
    url: '/collections/cgms',
    message: '<strong>Based on your responses, you qualify for a CGM.</strong>',
    buttonText: "Explore CGM's"
  },
  'yes-no-yes': {
    type: 'text',
    url: '/collections/cgms',
    message: '<strong>Based on your responses, you qualify for a CGM.</strong>',
    buttonText: "Explore CGM's"
  },
  'yes-no-no': {
    type: 'text',
    message: "<strong>Based on your responses, you do not qualify for a CGM at this time;</strong></br> However, if your doctor changes your treatment regime to include insulin therapy or you experience hypoglycemic lows under 54, please <a href=\"".concat(CONTACT_PAGE_URL, "\" class=\"eligibility-checker__link\">contact us</a> for further assistance.")
  },
  'no-yes-yes': {
    type: 'text',
    url: '/collections/cgms',
    message: '<strong>Based on your responses, you qualify for a CGM.</strong>',
    buttonText: "Explore CGM's"
  },
  'no-yes-no': {
    type: 'text',
    url: '/collections/cgms',
    message: '<strong>Based on your responses, you qualify for a CGM.</strong>',
    buttonText: "Explore CGM's"
  },
  'no-no-yes': {
    type: 'text',
    url: '/collections/cgms',
    message: '<strong>Based on your responses, you qualify for a CGM.</strong>',
    buttonText: "Explore CGM's"
  },
  'no-no-no': {
    type: 'text',
    message: "<strong>Based on your responses, you do not qualify for a CGM at this time;</strong></br> However, if your doctor changes your treatment regime to include insulin therapy or you experience hypoglycemic lows under 54, please <a href=\"".concat(CONTACT_PAGE_URL, "\" class=\"eligibility-checker__link\">contact us</a> for further assistance.")
  }
};
var STORAGE_KEY = 'eligibility_checker_answers';

// ============================================
// Question Item Component
// ============================================
var QuestionItem = _ref => {
  var {
    question,
    answer,
    hasError,
    onAnswerChange
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "eligibility-checker__question ".concat(hasError ? 'eligibility-checker__question--error' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
    className: "eligibility-checker__question-text"
  }, question.text), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "eligibility-checker__options"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("label", {
    className: "eligibility-checker__option"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("input", {
    type: "radio",
    name: question.id,
    value: "yes",
    checked: answer === 'yes',
    onChange: () => onAnswerChange(question.id, 'yes'),
    className: "eligibility-checker__radio"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "eligibility-checker__radio-custom"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "eligibility-checker__option-label"
  }, "Yes")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("label", {
    className: "eligibility-checker__option"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("input", {
    type: "radio",
    name: question.id,
    value: "no",
    checked: answer === 'no',
    onChange: () => onAnswerChange(question.id, 'no'),
    className: "eligibility-checker__radio"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "eligibility-checker__radio-custom"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "eligibility-checker__option-label"
  }, "No"))));
};

// ============================================
// Main Eligibility Checker Component
// ============================================
var EligibilityChecker = _ref2 => {
  var {
    shopifyData = {}
  } = _ref2;
  var {
    heading = 'Check Your Eligibility',
    headingSize = 'h2',
    subheading = 'Discover whether you\'re eligible for a Continuous Glucose Monitor (CGM) through your insurance.',
    textSize = 'text-base',
    buttonText = 'Check Eligibility'
  } = shopifyData;

  // Initialize state from localStorage or empty
  var [answers, setAnswers] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(() => {
    if (typeof window !== 'undefined') {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        try {
          return JSON.parse(saved);
        } catch (e) {
          return {};
        }
      }
    }
    return {};
  });

  // Result state - always starts fresh on page load (no persistence)
  var [result, setResult] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
  var [showResult, setShowResult] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [isAnimating, setIsAnimating] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [validationError, setValidationError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);

  // Save answers to localStorage whenever they change
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (typeof window !== 'undefined' && Object.keys(answers).length > 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(answers));
    }
  }, [answers]);

  // Handle answer selection
  var handleAnswerChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((questionId, value) => {
    setAnswers(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [questionId]: value
    }));
    setValidationError(false);

    // If result is showing, re-validate with new answer
    if (showResult) {
      setIsAnimating(true);
      setTimeout(() => {
        var newAnswers = _objectSpread(_objectSpread({}, answers), {}, {
          [questionId]: value
        });
        var key = QUESTIONS.map(q => newAnswers[q.id] || '').join('-');
        var outcome = OUTCOME_MAP[key];
        if (outcome) {
          if (outcome.type === 'redirect') {
            window.location.href = outcome.url;
          } else {
            setResult(outcome);
          }
        }
        setIsAnimating(false);
      }, 300);
    }
  }, [answers, showResult]);

  // Check if all questions are answered
  var allAnswered = QUESTIONS.every(q => answers[q.id]);

  // Handle form submission
  var handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    if (!allAnswered) {
      setValidationError(true);
      return;
    }
    var key = QUESTIONS.map(q => answers[q.id]).join('-');
    var outcome = OUTCOME_MAP[key];
    if (outcome) {
      if (outcome.type === 'redirect') {
        window.location.href = outcome.url;
      } else {
        setIsAnimating(true);
        setTimeout(() => {
          setResult(outcome);
          setShowResult(true);
          setIsAnimating(false);
        }, 300);
      }
    }
  }, [answers, allAnswered]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "eligibility-checker"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "eligibility-checker__container ".concat(isAnimating ? 'fade-out' : 'fade-in')
  }, !showResult ?
  /*#__PURE__*/
  // Form View
  react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "eligibility-checker__form"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "eligibility-checker__header"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h2", {
    className: "eligibility-checker__heading ".concat(headingSize)
  }, heading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
    className: "eligibility-checker__subheading ".concat(textSize)
  }, subheading)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "eligibility-checker__questions"
  }, QUESTIONS.map(question => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(QuestionItem, {
    key: question.id,
    question: question,
    answer: answers[question.id],
    hasError: validationError && !answers[question.id],
    onAnswerChange: handleAnswerChange
  }))), validationError && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
    className: "eligibility-checker__error"
  }, "Please answer all questions before checking eligibility."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    type: "button",
    className: "w-full btn btn--primary",
    onClick: handleSubmit
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "btn__text"
  }, buttonText))) :
  /*#__PURE__*/
  // Result View
  react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "eligibility-checker__result"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "eligibility-checker__result-content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h3", {
    className: "eligibility-checker__result-heading"
  }, "Result"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
    className: "eligibility-checker__result-message",
    dangerouslySetInnerHTML: {
      __html: (result === null || result === void 0 ? void 0 : result.message) || ''
    }
  }), (result === null || result === void 0 ? void 0 : result.url) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("button", {
    type: "button",
    className: "w-full btn btn--primary",
    onClick: () => {
      window.location.href = result.url;
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "btn__text"
  }, result.buttonText || "Explore CGM's"))))));
};

// ============================================
// Export initialization function
// ============================================
var initEligibilityChecker = () => {
  (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_2__["default"])(EligibilityChecker, '[data-eligibility-checker]', '[data-eligibility-checker-props]');

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('[data-eligibility-checker]')) {
      (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_2__["default"])(EligibilityChecker, '[data-eligibility-checker]', '[data-eligibility-checker-props]');
    }
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (initEligibilityChecker);

/***/ }),

/***/ "./js/sections/global-custom.js":
/*!**************************************!*\
  !*** ./js/sections/global-custom.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var ReactComponents_EligibilityChecker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ReactComponents/EligibilityChecker */ "./js/components/react/EligibilityChecker.js");

document.addEventListener('DOMContentLoaded', () => {
  (0,ReactComponents_EligibilityChecker__WEBPACK_IMPORTED_MODULE_0__["default"])();
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; (typeof current == 'object' || typeof current == 'function') && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"global-custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","shared"], () => (__webpack_require__("./js/sections/global-custom.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;